// extracted by mini-css-extract-plugin
export default {"ctaButton":"CTAButton_ctaButton__3N8Jr","ctaButtonText":"CTAButton_ctaButtonText__7Mkuy","noAnimation":"CTAButton_noAnimation__QWiAx"};